import { FORM_PATHS, openInModalOrPage } from '../../modals';
import { createFakeId } from '../../../reducers/util';

export const createDay = (eventType, startDate) => (dispatch, getState) => {
    dispatch(openInModalOrPage(FORM_PATHS.EditDayModal, createFakeId(), {}, startDate, eventType));
};
